import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";

const CategoryTable = ({ data = [], checkType }) => {
  return (
    <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 3 }}>
      <Table>
        {/* Header for summary */}
        <TableHead>
          <TableRow>
            <TableCell colSpan={4} sx={{ py: 1 }}>
              {data.length > 0 ? (
                <Typography
                  sx={{ color: "green", fontWeight: "bold", fontSize: 14 }}
                >
                  Танд нийт захиалсан бараа {data.length} ширхэг байна.
                </Typography>
              ) : checkType === 1 ? (
                <Typography
                  sx={{ color: "red", fontWeight: "bold", fontSize: 14 }}
                >
                  Танд ачаа ирээгүй байна.
                </Typography>
              ) : null}
            </TableCell>
          </TableRow>

          {/* Column Headers */}
          <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
            <TableCell sx={{ fontWeight: "normal" }}>№</TableCell>
            <TableCell sx={{ fontWeight: "normal" }}>
              Шилжүүлсэн огноо
            </TableCell>
            <TableCell sx={{ fontWeight: "normal" }}>Төлөв</TableCell>
            <TableCell sx={{ fontWeight: "normal" }}>Бараа</TableCell>
          </TableRow>
        </TableHead>

        {/* Table Body */}
        <TableBody>
          {data.map((category, index) => {
            // Format datetime string
           

            return (
              <TableRow key={index} sx={{ backgroundColor: "#fff" }}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{category.datetime}</TableCell>
                <TableCell>{category.location}</TableCell>
                <TableCell>
                  {category.length || category.namevalue || "-"}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CategoryTable;
